import React, { useState } from "react";
import styled from "@emotion/styled";

const TextComponent = ({ config, question, actions, activate }) => {
    const Wrapper = {
        width: "100%",
    };

    const Title = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        backgroundColor: "#3C3C3B",
        color: "white",
        fontSize: "3.5vh",
        padding: "2vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const Subtitle = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        color: "#3C3C3B",
        fontSize: "3.5vh",
        padding: "1vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const TypeTitle = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        color: "#3C3C3B",
        fontSize: "2.5vh",
        padding: "1vh",
        textAlign: "center",
        fontWeight: "bold",
        maxHeight: "30vh",
        minHeight: "10vh",
        maxWidth: "100vw",
        minWidth: "20vw",
    }

    const Label = styled.label`
        ${props => `
            width: "calc(100% - 4vh)",
            borderRadius: "1vh",
            color: "#3C3C3B",
            fontSize: "2.5vh",
            padding: "2vh",
            textAlign: "left",
            fontWeight: "bold",
        `};
    `;

    const OptionsWrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        margin: "1vh 0",
        padding: "3vh 0",
        overflow: "hidden",
        columnGap: "2vh",
        rowGap: "2vh",
        justifyContent: "center",
    };

    const CheckBoxWrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        margin: "1vh 0",
        padding: "1vh 0",
        overflow: "hidden",
        columnGap: "2vh",
        rowGap: "2vh",
        flexDirection: "column"
    };

    const WrapperBottom = {
        width: "100%",
        display: "flex",
        margin: "1vh 0",
        padding: "1vh 0",
        overflow: "hidden",
    };

    const Button = styled.button`
        width: 100%;
        border-radius: 1vh;
        border: none;
        background-color: ${activate ? "#00963f" : "#3C3C3B"};
        color: white;
        font-size: 3.5vh;
        padding: 2vh;
        text-align: center;
        font-weight: bold;
        pointer-events: auto; 
        cursor: pointer;
        
        ${activate ? "animation-name: activate; animation-iteration-count: infinite; animation-duration: 0.6s; animation-timing-function: linear; animation-direction: alternate; @keyframes activate {from { transform: scale(1.0); } to { transform: scale(0.95); }}" : ""}
    `;

    const Input = styled.input`
        ${props => `
            flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
            border-radius: 1vh;
            font-size: 2.5vh;
            text-align: center;
            padding: 1.5vh;
            font-weight: bold;
            max-height: 20vh;

            cursor: pointer;
            animation-timing-function: linear;
            animation-fill-mode: forwards;
            animation-duration: 0.4s;
            animation-iteration-count: 4;
            animation-delay: 0s;

            @keyframes select {
                0% { transform: rotate(0deg); }
                25% { transform: rotate(3deg); }
                50% { transform: rotate(0deg); }
                75% { transform: rotate(-3deg); }
                100% { transform:  rotate(0deg); }
            }
        `};
    `;

    return (
        <div style={Wrapper}>
            <div style={Title}>
                {config.getTranslatedText(question?.questionTitle)}
            </div>
            <div style={OptionsWrapper}>

                <textarea style={TypeTitle} placeholder={config.strings.freeTextHolder} rows="10" cols="50"
                    onChange={e => { actions.addFreeTextResponse("freeText", e.target.value) }}
                    value={question?.freeResponse?.freeText}
                />

                <div style={WrapperBottom}>
                    <div style={CheckBoxWrapper}>
                        <Button onClick={actions.acceptButton}>{config.strings.acceptButton}</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TextComponent;